import { render, staticRenderFns } from "./pdfTron.vue?vue&type=template&id=3786ece0&"
import script from "./pdfTron.vue?vue&type=script&lang=js&"
export * from "./pdfTron.vue?vue&type=script&lang=js&"
import style0 from "./pdfTron.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports